import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AdminSideBar } from "../../../modules/AdminSideBar";
import { OrdersPagination } from "../../../modules/OrdersPagination";

export const AdminOrders = () => {
  const navigate = useNavigate();
  const myUserType = useMemo(() => {
    const data = localStorage.getItem("auth-storage");
    return data ? JSON.parse(data).state?.user?.userType : null;
  }, []);

  useEffect(()=>{
    if(myUserType !== "admin"){
      alert("관리자 계정으로 로그인해주세요.")
      navigate("/admin")
    }
  }, [])

  // 관리자가 아니면 주문목록 컴포넌트를 렌더하지 않는다.
  // useEffect는 렌더 이후 실행되므로, 이 조기 반환이 없으면 리다이렉트 전에
  // OrdersPagination이 getPayments()로 전체 결제 데이터를 조회·노출하게 된다.
  if (myUserType !== "admin") {
    return null;
  }

  return (
    <>
      <div className="admin-background">
        <div className="layout-flex">
          <AdminSideBar />
          <main className="admin-main-content">
            <h2 className="admin-page-title">결제관리</h2>
            <OrdersPagination />
          </main>
        </div>
      </div>
    </>
  );
};
